import { render, staticRenderFns } from "./skuForm.vue?vue&type=template&id=500041f4&scoped=true"
import script from "./skuForm.vue?vue&type=script&lang=js"
export * from "./skuForm.vue?vue&type=script&lang=js"
import style0 from "./skuForm.vue?vue&type=style&index=0&id=500041f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500041f4",
  null
  
)

export default component.exports